/**
 * Content carousel (slider) with extensive options to control behaviour and appearance
 * @requires https://swiperjs.com/
 */

export default (() => {
  const carousels = document.querySelectorAll('[data-swiper]')
  if (carousels.length === 0) return

  const swiperInstances = []

  // Utility: Check if the element should be initialized based on optional breakpoint
  const shouldInit = (element) => {
    const breakpoint = element.dataset.swiperBreakpoint
    return breakpoint ? window.innerWidth <= parseInt(breakpoint, 10) : true
  }

  // Initialize Swiper instance
  const initSwiper = (element, options) => {
    const swiper = new Swiper(element, options) // eslint-disable-line no-undef
    swiperInstances.push(swiper)
    return swiper
  }

  // Destroy all Swiper instances
  const destroyAll = () => {
    swiperInstances.forEach((swiper) => {
      if (swiper?.destroy) swiper.destroy(true, true)
    })
    swiperInstances.length = 0
  }

  // Iterate over each element using the built-in forEach method
  /* eslint-disable no-unused-vars */
  const initialize = () => {
    carousels.forEach((value, index) => {
      let options, images

      // Skip initialization if current viewport doesn't match optional breakpoint
      if (!shouldInit(value)) return

      // Parse swiper options from the data attribute
      if (value.dataset.swiper !== undefined && value.dataset.swiper !== '') {
        options = JSON.parse(value.dataset.swiper)
        images = options?.thumbnails?.images
      }

      // Create a new Swiper instance
      /* eslint-disable no-undef */
      const swiper = initSwiper(value, options)
      /* eslint-enable no-undef */

      // Check if a controlled slider is specified
      if (options?.controlSlider) {
        const controlSelectors = Array.isArray(options.controlSlider)
          ? options.controlSlider
          : [options.controlSlider]

        const swiperControlledInstances = controlSelectors.map((selector) => {
          const controlledSlider = document.querySelector(selector)
          const controlledSliderOptions =
            controlledSlider?.dataset.swiper &&
            JSON.parse(controlledSlider.dataset.swiper)

          // Create a new Swiper instance for each controlled slider
          /* eslint-disable no-undef */
          return new Swiper(controlledSlider, controlledSliderOptions)
          /* eslint-enable no-undef */
        })

        swiper.controller.control = swiperControlledInstances
      }
    })
  }

  // Initialize on load
  initialize()

  // Re-initialize on window resize
  window.addEventListener('resize', () => {
    destroyAll()
    initialize()
  })
})()
